import { Component } from '@angular/core';
import { PremiumSyncService } from '@modules/policy/services/shared/premium-sync.service';


@Component({
  selector: 'app-vehicles',
  templateUrl: './vehicles.component.html',
  styleUrls: ['./vehicles.component.scss']
})
export class VehiclesComponent {
  readonly tab = 'vehicle'

  constructor(private premiumSyncService: PremiumSyncService) { }

  ngOnInit() {
  }
}
